<template>
  <div class="help">
    <div class="help__title">
      常见问题
      <i class="icon close" @click="close"></i>
    </div>
    <ul id="content" class="help__content">
      <li v-for="(item, index) in info" :key="index" class="help__content-item">
        <div class="help__content-title">{{ item.title }}</div>
        <div class="help__content-text">
          <p v-for="(g,index) in item.content" :key="index">{{ g }}</p>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>

export default {
  data() {
    return {
      info: [
        {
          title: '关于产品',
          content: ['我们所有产品均为定制预售产品。商品照片都为专业摄影师拍摄后和后期修正调整，尽量与现实商品保持一致。但由于灯光、显示器色彩偏差及个人对颜色理解各有不同，导致少数实物与照片可能存在色差以及尺寸问题。如无法接受请谨慎购买，一切以实物为准。谢谢您的理解。'],
        },
        { title: '关于发货', content: ['1、预售产品：产品入库之后，我们会根据付款先后顺序依次发货', '2、现货产品：商品付款后48小时内发货（节假日期间不发货）具体到货时间以快递为准。'] },
        {
          title: '关于退换货',
          content: ['我们申请售后的时间是产品签收后的15天，可以在芒果APP--我的---芒果好物---我---个人中心对应的产品下面有“申请售后”按钮。经过人工核实处理后，符合退款条件的，我们将会在10个工作日原路退款到您的购买的账户。', 'A：因为商品属于特殊订制产品，一经售出，不接受“无理由退/换货”', 'B：订制预售产品存在严重质量问题和在物流中心发生损毁的商品，如需寄回，无需您支付往返运费', 'C："节目同款" 产品：如果退货:需不影响二次销售的商品(不影响二次销售的商品)（即商品及包装保持出售时原状且配件赠品资料齐全的，如果有保护膜，保护膜也在的产品才能不影响第二次销售）寄回时，需要用户您支付往返运费', 'D: 如因您个人原因导致尺码有误、手机型号弄错，或者因您个人原因导致产品无法使用等。需要保证产品不影响二次销售（即商品及包装保持出售时原状且配件赠品资料齐全的，如果有保护膜，保护膜也在的产品才能不影响第二次销售）的情况下。进行换货处理，且用户您需承担往返的运费', 'E、如果是耳钉耳环类、内衣、袜子类等私人佩戴和穿戴物件，需当面签收，一经签收，不享受任何退换货处理，为了保证您的利益，请您在收到商品时，仔细检查，如果您发现有任何问题，请您当时指出，并退货或拒收'],
        },
        {
          title: '注意事项',
          content: ['A、不影响第二次销售包含但不限于：a.任何因非正常使用、保管或个人原因造成的商品损坏而影响二次销售（如自行修改尺寸，洗涤，皮具表面刮花、打油，刺绣，水洗、碰酸、碱、油或者触硬物，雨天穿着，长时间穿着，五金配件缺少，包括礼品类包装盒外直接缠胶带、贴快递单，等等），不予退换货；b.商品吊牌、商品配件（如配饰挂坠、肩带、小卡包等）、说明书、保修单、标签等丢失，不予退换货；c、礼盒保护膜撕坏或拆包；d、产品有明显使用痕迹；e、非正常条件下存储、暴露在潮湿环境中、暴露在温度过高或过低环境中；f、未经授权的修理、误用、疏忽、滥用、事故、改动；g、不正确的安装、不可抗力、食物或液体溅落、产品的正常磨损等；h、商品已打开塑封包装或撕开开箱即损贴纸、包装不完整、所附配件及资料不全、赠品不齐全。以上均不予退换货', '免责声明：芒果好物会随时根据市场情况及用户需求对服务条款进行变更，不再一一通知每位用户，请您随时关注服务条款的变化，并以最新公布的服务条款内容为准。您一旦在芒果好物上进行下单，我们将视为您已经同意上述政策及流程'],
        },
      ],
    };
  },
  mounted() {
    const height = document.body.clientHeight;
    const ele = document.getElementById('content');
    ele.style.maxHeight = `${height * 0.6}px`;
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
<style lang="scss" scoped>
.help {
  position: relative;
  padding: 90px 30px 30px 30px;
  width: 100%;
  box-sizing: border-box;

  &__title {
    font-size: 30px;
    color: #4a4a4a;
    font-weight: 500;
    text-align: center;
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 9px;
    line-height: 90px;
    background: #fff;

    i {
      position: absolute;
      right: 20px;
      top: 20px;
    }
  }

  &__content {
    overflow-y: scroll;

    &-item {
      & + & {
        margin-top: 30px;
      }
    }

    &-title {
      font-size: 26px;
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      color: #2d2d2d;

      &::before {
        content: '';
        display: block;
        width: 14px;
        height: 14px;
        background: rgba(255, 116, 35, 1);
        border-radius: 50%;
        margin-right: 19px;
      }
    }

    &-text {
      padding-left: 30px;
    }

    p {
      font-size: 24px;
      color: #7b7b7b;
    }
  }
}
</style>
